import { PaginatorSchema } from "src/types/PaginatorSchema";
import { setInstanceByEnvType } from "src/utils/helpers/requestApi/isServer";

export interface SecondCategoriesSchema {
  items: SecondCategoriesItemSchema[];
  paginator: PaginatorSchema;
  html_text: string;
}

export interface SecondCategoriesItemSchema {
  slug: string;
  image: string;
  brand_name: string;
  mnn: string;
  forms_amount: number;
  pharmacies_amount: number;
  min_price: number;
}

export interface SecondCategories {
  page: number;
  category_slug: string;
  city_slug: string;
}

export const getSecondCategories = (params: SecondCategories) =>
  setInstanceByEnvType().get<SecondCategoriesSchema>(
    "/catalog/secondary_category/brands",
    { params }
  );
